import AbstractKeys from '../all/AbstractKeys';

class ArrisKeys extends AbstractKeys {
  constructor() {
    super();
    this.keys = {
      UP: 38,
      DOWN: 40,
      LEFT: 37,
      RIGHT: 39,
      OK: 13,
      RED: 4113,
      GREEN: 4114, // No lo detectan las cajas de Arris. Por secuencia de números, el código fue supuesto.
      YELLOW: 4111,
      BLUE: 4112,
      BACK: 8,
      EXIT: 1158, // SALIR-EXIT

      ZERO: 48,
      ONE: 49,
      TWO: 50,
      THREE: 51,
      FOUR: 52,
      FIVE: 53,
      SIX: 54,
      SEVEN: 55,
      EIGHT: 56,
      NINE: 57,

      CH_UP: 427, // Deshabilitado por petición de Arris (Código viejo 81)
      CH_DOWN: 428, // Deshabilitado por petición de Arris (Código viejo 87)

      MUSIC: 90,
      VOD: 88,

      // PLAY: 80, //Para la caja de arris con NUC
      PLAY: 19, //Para laboratorio (PLAY/PAUSE) o play para cloudtv player
      PAUSE: 415, //Para laboratorio (PLAY/PAUSE) o pause para cloudtv player
      RWD: 412,
      FWD: 417,
      STOP: 413,
      // REC: 416, Se comenta más no se borra ya que sí existe el botón pero no está activa la función

      PPV: 86,
      MOSAIC: 77,
      GUIDE: 458, // Deshabilitado por petición de Arris (Código viejo 78)
      MENU: 462, // Deshabilitado por petición de Arris (Código viejo 72)

      FAV: 171,
      PREV: 69,

      INFO: 457,

      LIST: 1808, // LIST-PVR
      HELP: 156, // AYUDA
      HD: 72

      //Extra Arris Buttons Without functionality
      // AUDIO: 4111, the same as the YELLOW ONE
      // SUB-T: 4112, the same as the NLUE ONE
    };
  }
}

export default ArrisKeys;



// WEBPACK FOOTER //
// ./src/devices/arris/Keys.js